import React, {useCallback, useEffect, useState, Suspense, lazy } from 'react';
import { compose } from 'recompose';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import carouselCss from "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import style from "./style.scss";
import ChevronLeftIcon from '../../../travelerProfile/components/icons/ChevronLeftIcon';
import ChevronRightIcon from '../../../travelerProfile/components/icons/ChevronRightIcon';
import { FileUploadIcon } from '../../../../styledComponents/styles/IconCustom.styled';

export const enhance = compose(withStyles(style, carouselCss));

const Carousel = lazy(() =>
  import("react-responsive-carousel").then((mod) => ({ default: mod.Carousel }))
);

function ImageCarousel({carouselImages,type, handleUploadClick, userType}) {
  const [images, setImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0); 

  useEffect(()=>{
      let selectedImages = [];
      if(carouselImages?.length>0) {
        selectedImages = carouselImages.map((image)=>{
          return  {
            "original" : type==="plan" ? image?.background : image?.attributes?.background,
            "alt_text" :  type==="plan" ? image?.alt_text :  image?.attributes?.alt_text,
          }
        });
      }
      setImages(selectedImages);
  },[carouselImages])
  
    const next = useCallback(() => {
        setCurrentSlide((prev) => prev + 1);
    }, []);
  
    const prev = useCallback(() => {
        setCurrentSlide((prev) => prev - 1);
    }, []);
  
    const updateCurrentSlide = useCallback((index) => {
      setCurrentSlide((prev) => (prev !== index ? index : prev));
    }, []);

  return (
    <div className={`${style['content']} ${type === 'plan' ? style['plan-content'] : ''}`}>
      {images?.length>1 &&
        <>
          <button type="button" className={`${style.customPrevButton} ${type === 'plan' ? `${style['plan-nav-button-prev']} ${style['plan-nav-button']}` : ''}`} onClick={prev}>
            {type === 'plan' ? (
              <div className={style.navButtonInner}>
                <ChevronLeftIcon fillColor={"#446372"} />
              </div>
            ) : (
              <ChevronLeftIcon fillColor={"white"} />
            )}
          </button>
          <button type="button" className={`${style.customNextButton} ${type === 'plan' ? `${style['plan-nav-button-next']} ${style['plan-nav-button']}` : ''}`} onClick={next}>
            {type === 'plan' ? (
              <div className={style.navButtonInner}>
                <ChevronRightIcon fillColor={"#446372"} />
              </div>
            ) : (
              <ChevronRightIcon fillColor={"white"} />
            )}
          </button>
          <div className={`${style.carouselWrapper} ${type === 'plan' ? style['plan-carousel'] : ''}`}>
            {userType==="admin" && type==="plan" &&
              <div className={type === 'plan' ?  style['upload-button-container-caraousel-plan'] :  style['upload-button-container-caraousel']}>
                <button 
                  className={style['upload-button']}
                  onClick={handleUploadClick}
                  type="button"
                >
                  <FileUploadIcon size="48"/>
                </button>
              </div>
            }
            <Suspense fallback={<div>Loading...</div>}>
              <Carousel
                showStatus={false}
                showArrows={false}
                selectedItem={currentSlide} 
                onChange={updateCurrentSlide}
                autoPlay={true}
                infiniteLoop
                lazyLoad={true}
              >
                {images.map((item, index)=>(
                  <div key={index} className={`${style.carouselItem} ${type === 'plan' ? style['plan-carousel-item'] : ''}`}>
                    <img 
                      src={item.original} 
                      alt={item.alt_text}
                    />
                  </div>
                ))}
              </Carousel>
            </Suspense>
          </div>
        </>
      }
      {images?.length===1 &&
        <div className={`${style.programImageWrapper} ${type === 'plan' ? style['plan-image-wrapper'] : ''}`}>
          {userType==="admin" && type==="plan" &&
            <div className={style['upload-button-container']}>
              <button 
                className={style['upload-button']}
                onClick={handleUploadClick}
                type="button"
              >
                <FileUploadIcon size="48"/>
              </button>
            </div>
          }
          <div className={`${style.imageContainer} ${type === 'plan' ? style['plan-image-container'] : ''}`}>
            <img src={images[0]?.original} alt={images[0]?.alt_text} />
          </div>
        </div>
      }
    </div>
  );
}

export default enhance(ImageCarousel);